import { Stars } from "./Stars";
import { fmtDecimal } from "../utils/formatters";

/**
 * Médias por dimensão respeitando a ORDEM e LABEL configurados em
 * Impulsione → Campanhas → Avaliação. Quando `dimensions` é fornecido,
 * exibe `d.label` (ex: "Como foi a comida?") em vez de capitalize(key).
 * Esconde se houver só 1 dimensão (não vale exibir o card).
 */
export function DimensionAverages({ dimensions = [], medias = {} }) {
  const keys = Object.keys(medias || {});
  if (keys.length <= 1) return null;
  // Ordena: primeiro as dimensões da campanha (na ordem), depois órfãs alfabéticas.
  const ordered = [];
  const seen = new Set();
  for (const d of dimensions) {
    if (d.key && medias[d.key] != null) {
      ordered.push({ key: d.key, label: d.label || d.key, avg: medias[d.key] });
      seen.add(d.key);
    }
  }
  for (const k of keys.sort()) {
    if (!seen.has(k)) ordered.push({ key: k, label: cap(k), avg: medias[k] });
  }

  return (
    <div className="bg-card border rounded-2xl p-5">
      <h2 className="text-sm font-bold uppercase tracking-wider text-muted-foreground mb-3">
        Médias por dimensão
      </h2>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3">
        {ordered.map(({ key, label, avg }) => (
          <div key={key} className="bg-muted/40 rounded-xl p-3">
            <p className="text-xs text-muted-foreground">{label}</p>
            <div className="flex items-baseline gap-1 mt-0.5">
              <span className="text-2xl font-bold text-amber-500">{fmtDecimal(avg)}</span>
              <span className="text-xs text-muted-foreground">/ 5,0</span>
            </div>
            <Stars value={avg} />
          </div>
        ))}
      </div>
    </div>
  );
}

const cap = (s) => (s || "").charAt(0).toUpperCase() + (s || "").slice(1);
